/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { pastDueNoticeEntityAsync } from './DataActionExtension.g';

/**
 * PastDueNotice Input Action
 */
export class PastDueNoticeInput implements Msdyn365.IActionInput {
    constructor() {}

    public getCacheKey = () => `PastDueNotice`;
    public getCacheObjectType = () => 'PastDueNotice';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

export interface IPastDueNoticeData {
    hasAccountInCredit: boolean;
}

const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new PastDueNoticeInput();
};

async function action(input: PastDueNoticeInput, ctx: Msdyn365.IActionContext): Promise<IPastDueNoticeData> {
    if (!ctx.requestContext.user.isAuthenticated) {
        return { hasAccountInCredit: false };
    }
    const resp = await pastDueNoticeEntityAsync({ callerContext: ctx });
    return { hasAccountInCredit: resp.HasAccountInCredit };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IPastDueNoticeData>>action,
    id: 'PastDueNotice',
    input: createInput
});
